import { useChainId } from "@gu-corp/gu-wallet-connector";
import { env } from "../libraries/utils/env";

export default function useIsInTheWrongNetwork() {
  const chainId = useChainId();

  return chainId !== +(env.REACT_APP_CHAIN_ID as string);
}
